import { render, staticRenderFns } from "./ChooseStar.vue?vue&type=template&id=56768b46&scoped=true"
import script from "./ChooseStar.vue?vue&type=script&lang=js"
export * from "./ChooseStar.vue?vue&type=script&lang=js"
import style0 from "./ChooseStar.vue?vue&type=style&index=0&id=56768b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56768b46",
  null
  
)

export default component.exports